import type { KeyboardEvent as ReactKeyboardEvent } from 'react';

/**
 * True while an IME (Korean, Japanese, …) is still composing: Enter or Escape
 * then only confirms or drops the syllable. Safari sends keyCode 229 without
 * isComposing for the Enter that ends a Korean composition.
 */
export function isComposing(event: KeyboardEvent | ReactKeyboardEvent): boolean {
  const native = 'nativeEvent' in event ? event.nativeEvent : event;
  return native.isComposing || native.keyCode === 229;
}

/**
 * Whether Enter sends. Not on a touch screen (a phone, a tablet): its keyboard has no Shift+Enter, so Enter
 * makes a new line there and the send button sends.
 */
export function enterSends(): boolean {
  return typeof window === 'undefined' || window.matchMedia?.('(pointer: coarse) and (hover: none)').matches !== true;
}

/** How long a finger holds a control for its second action (a message's menu, "예약 전송" on send). */
export const LONG_PRESS_MS = 500;
